import { useEffect, useState } from "react";

import {
    Chip,
} from "@mui/material";

import MUIDataTable from "mui-datatables";

import { useNavigate } from "react-router-dom";

import { paymentGatewayConfigurationApi } from "../API/paymentGatewayConfigurationApi";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import Breadcrumb from "../NewUI/NewComponents/Breadcrumb";

export default function ConfigurationList() {

    const navigate = useNavigate();

    const [rows, setRows] = useState([]);

    const loadConfigurations = async () => {

        const response =
            await paymentGatewayConfigurationApi.getAll();

        setRows(
            response.data?.data ||
            response.data ||
            []
        );
    };

    useEffect(() => {
        loadConfigurations();
    }, []);

    const columns = [

        {
            name: "id",
            label: "ID",
        },

        {
            name: "tenantId",
            label: "Tenant",
        },

        {
            name: "gateway",
            label: "Gateway",
            options: { customBodyRender: (v) => (v && (v.code || v.displayName)) || '' },
        },

        {
            name: "production",
            label: "Environment",
            options: {
                customBodyRender: (value) => (
                    <Chip
                        label={value ? "PRODUCTION" : "SANDBOX"}
                        color={value ? "error" : "warning"}
                        size="small"
                    />
                ),
            },
        },

        {
            name: "merchantId",
            label: "Merchant",
        },
        {
            name: "active",
            label: "Status",
            options: {
                customBodyRender: (value) => (
                    <Chip
                        label={value ? "ACTIVE" : "INACTIVE"}
                        color="success"
                        size="small"
                    />
                ),
            },
        },

        {
            name: "id",
            label: "Actions",
            options: {
                customBodyRender: (value) => (

                    <div className="tw-flex tw-gap-2">
                        <button
                            className="btn btn-sm hovbuttonColour"
                            onClick={() =>
                                navigate(
                                    `/gateway-configurations/${value}/edit`
                                )
                            }
                        >
                            Edit
                        </button>
                        <button
                            className="btn btn-sm btn-danger"
                            onClick={async () => {
                                if (!window.confirm('Delete this configuration?')) return;
                                await paymentGatewayConfigurationApi.delete(value);
                                loadConfigurations();
                            }}
                        >
                            Delete
                        </button>
                    </div>

                ),
            },
        },
    ];

    const options = {
        filterType: "dropdown",
        selectableRows: "none",
        responsive: "standard",
    };

    return (

        <div>
            <Header />
            <Menu />
            <div className="content-wrapper">
                <div className="UI-container">
                    <div className="UI-card">
                        <div className="UI-header">
                            <Breadcrumb breadcrumbs={[{ name: "Home", path: "/superadminmasters" }, { name: "Payment Gateways", path: null }]} />
                            <div className="UI-header-content">

                                <div>
                                    <h1 className="UI-title">
                                        Gateway Configurations

                                    </h1>
                                    <p className="UI-subtitle">
                                        List of all Gateway Configurations
                                    </p>
                                </div>
                                <div className="UI-header-actions">
                                    <button className="UI-btn UI-btn-primary"
                                        onClick={() =>
                                            navigate(
                                                "/gateway-configurations/create"
                                            )
                                        }
                                    >
                                        Add Configuration
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="UI-form-container">

                            <MUIDataTable
                                title=""
                                data={rows}
                                columns={columns}
                                options={options}
                            />

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}